import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useTheme,
} from "@mui/material";
import { LevelSelectForm } from "../../../../../../../components/LevelSelectForm/LevelSelectForm";
import { IMPACT_LEVELS, LIKELIHOOD_LEVELS } from "../../../../utils/riskUtils";

const OverrideModal = ({ open, onClose, onSave, currentRisk }) => {
  const [editValues, setEditValues] = useState({
    inherent_impact: currentRisk?.inherent_impact,
    inherent_likelihood: currentRisk?.inherent_likelihood,
  });

  useEffect(() => {
    if (open && currentRisk) {
      setEditValues({
        inherent_impact: currentRisk.inherent_impact ?? 1,
        inherent_likelihood: currentRisk.inherent_likelihood ?? 1,
      });
    }
  }, [open, currentRisk]);

  const handleCancel = () => {
    onClose();
  };

  const handleSave = () => {
    onSave({
      inherent_impact: editValues?.inherent_impact,
      inherent_likelihood: editValues?.inherent_likelihood,
    });
    onClose();
  };

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="xs"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          width: "100%",
          maxWidth: "320px",
          margin: "16px",
          overflowX: "hidden",
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: "16px", pb: 1 }}>
        Override Inherent Risk
      </DialogTitle>
      <DialogContent sx={{ pt: 1, px: 2, overflowX: "hidden" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
            pt: 1,
          }}
        >
          <LevelSelectForm
            label="Impact"
            options={IMPACT_LEVELS}
            value={editValues?.inherent_impact}
            onChange={(value) =>
              setEditValues((prev) => ({ ...prev, inherent_impact: value }))
            }
            disabled={false}
          />
          <LevelSelectForm
            label="Likelihood"
            options={LIKELIHOOD_LEVELS}
            value={editValues?.inherent_likelihood}
            onChange={(value) =>
              setEditValues((prev) => ({ ...prev, inherent_likelihood: value }))
            }
            disabled={false}
          />

          <Box sx={{ display: "flex", justifyContent: "center", my: 1 }}>
            <Box
              sx={{
                p: 1.5,
                backgroundColor: theme.customColors.background.dialog,
                borderRadius: 1,
                border: `1px solid ${theme.customColors.border.accent}`,
                textAlign: "center",
                width: "220px",
                maxWidth: "100%",
              }}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mb: 0.5 }}
              >
                New Score
              </Typography>
              <Typography variant="h4" fontWeight={700} color="primary">
                {editValues?.inherent_impact * editValues?.inherent_likelihood}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button
          onClick={handleCancel}
          variant="outlined"
          size="small"
          sx={{ fontSize: "13px" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          size="small"
          color="primary"
        >
          Override
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OverrideModal;
